export default "__VITE_ASSET__ce07b5e8__"